<template>
  <div :class="$style.base">
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" module>
.base {
  display: none;
  position: absolute;
  background-color: black;
  color: white;
  text-align: center;
  top: 0;
  font-size: 12px;
  min-width: 160px;
  transform: translateY(calc(-100% - #{$spacing}));
  padding: $spacing * 0.5;
  border-radius: $border-radius;
  text-transform: none;

  &:after {
    content: '';
    position: absolute;
    border-left: $spacing * 0.5 solid transparent;
    border-right: $spacing * 0.5 solid transparent;
    border-top: $spacing * 0.5 solid black;
    bottom: 0;
    right: 50%;
    transform: translateX(50%) translateY(100%);
  }

  :hover > & {
    display: block;
  }
}
</style>
